const AnnualReturnChart = require('./AnnualReturnChart');

module.exports = AnnualReturnChart;
